import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthAccessProvider } from '../core/core.auth';
import { MessageProvider } from '../service/message.service'
import { UserService} from '../service/user.service';
import { AssenzeService} from '../service/assenze.service';
import { AppConstants } from '../core/app.constants';
import { Router } from '@angular/router';
import { UserContext, BaseComponent, AbsenceCause, WorkedDaysResponse, Absence, AbsenceResponse, User, UserInfo} from '../core/core.component';
import { SelectItem } from 'primeng/primeng';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { ReportService } from 'app/service/report.service';
import { BusyProvider } from 'app/service/busy.service';

declare var $: any;
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-assenze-prospect',
  templateUrl: './assenze-prospect.component.html',
  styleUrls: ['./assenze-prospect.component.css'],
  host: { '(window:keydown)': 'shortcutHandler($event)' }
})
export class AssenzeProspectComponent extends BaseComponent implements OnInit, OnDestroy
{
    static DIALOG_ID: string = "detailDailyAbsence";
    maxScrollableArea: string = "50px";
    userContext: UserContext;
    userInfo: UserInfo = new UserInfo();
    currentUserDes: string = null;
    months: SelectItem[] = [];
    monthSelected: number = 0;
    years: SelectItem[] = [];
    yearSelected: number = 0;
    weekEvents: WeekEvent[] = [];
    completed: boolean =  true;
    absences: Absence[] = [];
    workedDays: string[] = [];
    colorMap: Map<string, string> = new Map();
    eventCalendarSelected: EventCalendar = new EventCalendar();
    showDetailDay: boolean = false;
    infoMessage: string = null;
    errorMessage: string = null;
    previousEnabled = false;
    nextEnabled = false;

    showFilter = false;
    usersSelected: SelectItem[] = [];
    filterUsers: SelectItem[] = [];
    filterUsername: SelectItem[] = [];
    filteredUsers: SelectItem[] = [];
    usersGroupFilter = false;
    gruppi: SelectItem[]=[];
    gruppiUsers: SelectItem[] = [];
    numgruppi: number = null;

    causes: AbsenceCause[] = [];
    causeItems: SelectItem[] = [];
    hours: SelectItem[] = [];
    
    refreshSubscription: Subscription = null;

    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider,
            private assenzeService: AssenzeService,
            private userService: UserService,
            private datePipe: DatePipe,
            private busyProvider: BusyProvider,
            private reportService: ReportService) 
    { 
        super(authAccess, router, messageProvider);
        this.messageProvider.clearAll();
        this.userContext = this.authAccess.getUserContext();
        this.currentUserDes = this.userContext.userId.charAt(0).toLocaleUpperCase() + this.userContext.userId.substr(1);
    }

  ngOnDestroy() {
      if(this.refreshSubscription != null) {
          this.refreshSubscription.unsubscribe();
      }
  }

  ngOnInit() 
  {
      this.userContext = this.authAccess.getUserContext();
      if(this.userContext == null) {    
          this.authAccess.invalidate();
      } else {
       
          this.months.push({label: "Gennaio", value: 0});
          this.months.push({label: "Febbraio", value: 1});
          this.months.push({label: "Marzo", value: 2});
          this.months.push({label: "Aprile", value: 3});
          this.months.push({label: "Maggio", value: 4});
          this.months.push({label: "Giugno", value: 5});
          this.months.push({label: "Luglio", value: 6});
          this.months.push({label: "Agosto", value: 7});
          this.months.push({label: "Settembre", value: 8});
          this.months.push({label: "Ottobre", value: 9});
          this.months.push({label: "Novembre", value: 10});
          this.months.push({label: "Dicembre", value: 11});
          
          this.hours.push({label: "1", value: 1});
          this.hours.push({label: "2", value: 2});
          this.hours.push({label: "3", value: 3});
          this.hours.push({label: "4", value: 4});
          this.hours.push({label: "5", value: 5});
          this.hours.push({label: "6", value: 6});
          this.hours.push({label: "7", value: 7});
          this.hours.push({label: "8", value: 8});
          
          let now: Date = new Date();
          this.monthSelected = now.getMonth();
          this.refreshSubscription = this.assenzeService.getRefreshEvent().subscribe(
                  event => {
                      this.switchMonth(false, false);
                  }
          );
          this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
               result => {
                  this.userInfo = result;
                  if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
                    this.userInfo.managedUsers.push(this.userContext.userId);
                  }
               },
               error => {
                  this.handleError(error);
               });
          }

          this.assenzeService.getDistinctYears(this.userContext.srmToken).subscribe(
              result => {
                  for(let i = 0; i < result.years.length; ++i) {
                      let year = result.years[i];
                      this.years.push({label: year + "", value: year});
                  }
                  this.yearSelected = new Date().getFullYear();
                  this.switchMonth();
               },
               error => {
                  this.handleError(error);
               }    
          );
      
          this.assenzeService.getAbsenceCauses(this.userContext.srmToken).subscribe(
               result => {
                  this.causes = result.absenceCauses;
                  for(let i = 0; i < this.causes.length; ++i) {
                      let current = this.causes[i];
                      let des = current.description;
                      let startChar = des.charAt(0);
                      des = (startChar + "").toUpperCase() + des.substring(1);
                      this.causeItems.push({label: des, value: current.id});
                  }
               },
               error => {
                  this.handleError(error);
               }
          );

          this.userService.getUsers(this.userContext.srmToken, true).subscribe(
                result => {
                    for(var i = 0; i <  result.users.length; ++i) {
                        var current: User =  result.users[i];
                        this.filterUsers.push({label: current.fullname, value: current.id});
                        this.filterUsername.push({label: current.username, value: current.id});
                        this.gruppiUsers.push({ label: this.getGruppoUser(current), value: current.id});
                    }
                    this.gruppi=[];
                            this.numgruppi=0;
                            this.gruppi.push({ label: "Tutti i gruppi", value: this.numgruppi });
                            for (const key in this.userInfo.managedUsersMap) {
                                this.numgruppi++;
                                this.gruppi.push({ label: key, value: this.numgruppi });
                        
                            }

                },
                error => {
                    this.handleError(error);
                }
          );
  }

  filterUser(event) 
  {
      this.filteredUsers = AppConstants.filterSuggestions(this.filterUsers, event.query, item => [item.label]);
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  applyUsersFilter() {
    this.reload(); 
    this.showFilter = false;
    this.usersGroupFilter = false;
  }

  applyUsersGroupFilter() {
    this.usersSelected = [];
    if(this.gruppi.length>=3){
        this.showFilter=true;
    }
    this.usersGroupFilter = !this.usersGroupFilter;
    if (this.usersGroupFilter) {
        for (let i = 0; i < this.filterUsername.length; i++) {
            let item = this.filterUsername[i];
            if (this.userInfo.managedUsers.indexOf(item.label.toLowerCase()) != -1) {
                item=this.filterUsers[i];
                this.usersSelected.push(item);
            }
        }
    }
    this.reload();
  }

  filterUtentiGruppi (event){
    this.usersSelected = [];
    if (event==0){
        for (let i = 0; i < this.filterUsername.length; i++) {
            let item = this.filterUsername[i];
            if (this.userInfo.managedUsers.indexOf(item.label.toLowerCase()) != -1) {
                item=this.filterUsers[i];
                this.usersSelected.push(item);
            }
        }
    }
    else{
        const usernames = this.userInfo.managedUsersMap[this.getGruppo(event)];
       
    if (Array.isArray(usernames)) {
        for (let username of usernames) {
            const user = this.filterUsername.find(u => 
                u.label.toLowerCase().includes(username.toLowerCase()) 
            );
            if (user) {
                let item=this.filterUsers.find(u => 
                    u.value == user.value)

                this.usersSelected.push({ label: item.label, value: item.value });
            }
        }
    }
    }
    this.reload();

}

  private shiftDay(date: Date, numberDays : number) : Date
  {
      let shiftedDate : Date = new Date(date.getTime() + (1000 * 60 * 60 * (24 * numberDays)));
      return shiftedDate;
  }

  initCalendar(month: number, year: number)
  {
      if(month == 0 && year == this.years[0].value) {
          this.previousEnabled = false;
      } else {
          this.previousEnabled = true;
      }
      
      if(month == 11 && year == this.years[this.years.length - 1].value) {
          this.nextEnabled = false;
      } else {
          this.nextEnabled = true;
      }
      this.weekEvents = [];
      let currentDate = new Date();
      currentDate.setFullYear(year, month, 1); // primo giorno del mese
      let dayOfWeek = currentDate.getDay(); // giorno della settimana
      
      // se non è lunedì si riporta indietro il calendario al primo lunedì disponibile
      // anche se del mese precedente, quindi si calcolano sempre 30 giorni escludendo sabato e domenica
      
      if(dayOfWeek > 1) {
          currentDate = this.shiftDay(currentDate, -(dayOfWeek - 1));
      }
      let counter = 0;
      let events: EventCalendar[] = [];
      for(let i = 0; i < 42; ++i) 
      {
          // esclude sabato e domenica
          if(currentDate.getDay() != 6 && currentDate.getDay() != 0)
          {
              let currentEvent: EventCalendar = new EventCalendar();
              let date = new Date();
              date.setFullYear(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
              currentEvent.enabled = this.validateDay(currentDate);
              currentEvent.isToday = AppConstants.isToday(currentDate);
              currentEvent.date = date;
              if(currentEvent.enabled) {
                  this.fillEvent(currentEvent);
                  this.sort(currentEvent);
                  let MAX = 20;
                  if(currentEvent.users.length > MAX) 
                  {
                     let diff = currentEvent.users.length - MAX; 
                     currentEvent.users = currentEvent.users.slice(0, MAX);
                     currentEvent.users.push({user: "+ " + diff, color: "gray", decorationSx: "", decorationDx: "", userId: ""});
                  }
              }
              events.push(currentEvent);
              ++counter;
              if(counter == 5) {
                  let currentWeek: WeekEvent = new WeekEvent();
                  currentWeek.weekId = this.weekEvents.length + 1;
                  currentWeek.events = events;
                  this.weekEvents.push(currentWeek);
                  counter = 0;
                  events = [];
              }
          }
          currentDate = this.shiftDay(currentDate, 1);
      }
  }

  saveChange(absence: Absence)
  {
      this.infoMessage = null;
      this.errorMessage = null;
      this.assenzeService.updateAssenza(this.userContext.srmToken, absence).subscribe(
          result => {
              absence.desUserIns = this.currentUserDes;
              absence.tsModif = new Date();
              this.infoMessage = "Modifica eseguita correttamente";
          },
          error => {
              this.assenzeService.fireRefreshEvent();
              this.errorMessage = this.retrieveError(error);
          }
      );
  }

  switchYear()
  {
      this.switchMonth(true);
  }

  switchMonth(loadingIndicator?: boolean, cleanMessage?: boolean) 
  {
      if(cleanMessage == null || typeof(cleanMessage) == 'undefined' || cleanMessage == true) {
          this.messageProvider.clearAll();
      }
      this.completed = loadingIndicator != null && typeof(loadingIndicator) != 'undefined' ? !loadingIndicator : false;
      this.absences = [];
      this.workedDays = [];
      let assenzeResponse: AbsenceResponse;
      let workedDaysResponse: WorkedDaysResponse;
      
      let observables: Observable<any>[] = [];
      
      let userIds = [];
      this.usersSelected.forEach(user => {
        userIds.push(user.value);
      });

      observables.push(this.assenzeService.getAssenze(this.userContext.srmToken, this.monthSelected, this.yearSelected, userIds));
      observables.push(this.assenzeService.getWorkedDaysMonthly(this.userContext.srmToken, this.monthSelected, this.yearSelected));
     
      Observable.forkJoin(observables).subscribe(
             results => {
                 assenzeResponse = results[0];
                 this.absences = assenzeResponse.absences;
                 
                 workedDaysResponse = results[1];
                 for(let i = 0; i < workedDaysResponse.days.length; ++i) {
                     this.workedDays.push(this.datePipe.transform(workedDaysResponse.days[i], "yyyyMMdd"));
                 }
                 this.completed = true;
                 this.initCalendar(this.monthSelected, this.yearSelected);
             },
             error => {
                 this.completed = true;
                 this.handleError(error);
             }
      );
  } 

  reload(loadingIndicator?: boolean) {
      this.switchMonth(loadingIndicator);
  }

  openDetailDay(eventCalendar: EventCalendar) 
  {
      this.infoMessage = null;
      this.errorMessage = null;
      if(!eventCalendar.enabled) {
          return;
      }
      this.eventCalendarSelected = new EventCalendar();
      this.eventCalendarSelected.date = eventCalendar.date;
      this.eventCalendarSelected.enabled = eventCalendar.enabled;
      this.eventCalendarSelected.isToday = eventCalendar.isToday;
      this.eventCalendarSelected.users = eventCalendar.users;
      this.eventCalendarSelected.absences = [];
      for (let i = 0; i < eventCalendar.absences.length; i++) {
        if (eventCalendar.absences[i].causale != null) {
            this.eventCalendarSelected.absences.push(eventCalendar.absences[i]);
        }
      }   

      this.showDetailDay = true;
      $("#" + AssenzeProspectComponent.DIALOG_ID).modal({backdrop: 'static', keyboard: false});
  }
  
  closeDetailDay() {
      this.showDetailDay = false;
      $("#" + AssenzeProspectComponent.DIALOG_ID).modal("hide");
  }

  removeAbsence(absence: Absence)
  {
      this.infoMessage = null;
      this.errorMessage = null;
      this.assenzeService.deleteAssenza(this.userContext.srmToken, absence.date, absence.userId).
      subscribe(
           result => {
               this.infoMessage = result.message;
               
               var index = this.eventCalendarSelected.absences.indexOf(absence, 0);
               if (index > -1) {
                   this.eventCalendarSelected.absences.splice(index, 1);
               }
               this.assenzeService.fireRefreshEvent();
           },
           error => {
               this.errorMessage = this.retrieveError(error);
           }
      );
  }
  
  private validateDay(date: Date) : boolean
  {
      let dateString = this.datePipe.transform(date, "yyyyMMdd");
      return this.workedDays.indexOf(dateString) >= 0 && date.getMonth() == this.monthSelected;
  }
  
  private fillEvent(eventCalendar: EventCalendar)
  {
      let dateString = this.datePipe.transform(eventCalendar.date, "yyyyMMdd");
      
      let filteredAbsences = this.absences.filter((absence)=> this.datePipe.transform(absence.date, "yyyyMMdd") == dateString);
      filteredAbsences.forEach((absence) => {
          eventCalendar.absences.push(absence);
          eventCalendar.users.push(this.getUserColor(absence.fullname, absence));
      });
  }
  
  private sort(eventCalendar: EventCalendar)
  {
      eventCalendar.users.sort((u1, u2) => {
          if(u1.user == u2.user) return 0;
          return u1.user > u2.user ? 1 : -1;
      });
      eventCalendar.absences.sort((a1, a2) => {
          if(a1.fullname == a2.fullname) return 0;
          return a1.fullname > a2.fullname ? 1 : -1;
      });
  }
  
  private getUserColor(fullname: string, absence: Absence) {
      if (this.colorMap.has(absence.username)) {
          return {user: fullname, color: this.colorMap.get(absence.username), decorationSx: this.getCausalUserDecoration(absence.causale), decorationDx: this.getPresenceUserDecoration(absence), userId: absence.username.toLowerCase(), typeDay: absence.typeDay};
      } else {
          let color = AppConstants.intToRGB(AppConstants.hashCode(absence.username + "." + absence.userId));
          this.colorMap.set(absence.username, color);
          return {user: fullname, color: color, decorationSx: this.getCausalUserDecoration(absence.causale), decorationDx: this.getPresenceUserDecoration(absence), userId: absence.username.toLowerCase(), typeDay: absence.typeDay};
      }
  }
  
  private getCausalUserDecoration(causale: string) : string {
      if ("A" == causale) return "glyphicon glyphicon-text-background";
      if ("M" == causale) return "glyphicon glyphicon-bed";
      if ("P" == causale) return "glyphicon glyphicon-bell";
      
      return "";
  }
 
  private getPresenceUserDecoration(absence: Absence) : string {
    if (absence.presentNow) {
        return "glyphicon glyphicon-user";
    } else if (absence.causale == null) {
        return "glyphicon glyphicon-time";
    }
    return "";
  }
  
  previousMonth() {
      if(this.monthSelected > 0) {
          this.monthSelected -= 1; 
          this.switchMonth();
      }
      else if(this.monthSelected == 0 && this.yearSelected > this.years[0].value) {
          this.monthSelected = 11;
          this.yearSelected -= 1;
          this.switchMonth();
      }
  }

  nextMonth() {
      if(this.monthSelected < 11) {
          this.monthSelected += 1; 
          this.switchMonth();
      }
      else if(this.monthSelected == 11 && this.yearSelected < this.years[this.years.length - 1].value) {
          this.monthSelected = 0;
          this.yearSelected += 1;
          this.switchMonth();
      }
  }
  
  openAssenzaDialog() {
      this.assenzeService.openAssenzeDetail();
  }

  openAssenzaMalattiaDialog() {
      this.assenzeService.openAssenzeMalattiaDetail();
  }
  
  openAssenzaDialogToSelectedDay() {
      this.infoMessage = null;
      this.errorMessage = null;
      this.closeDetailDay();
      this.assenzeService.openAssenzeDetail(this.eventCalendarSelected.date);
  }

  shortcutHandler(event) { 
      if(this.showDetailDay == false) { return; }
      if (event.keyCode == 27) { // ESC
          this.closeDetailDay();
      }
  }

    exportReport() {

        this.busyProvider.showBusyIndicator();
        this.messageProvider.clearAll();

        let from = new Date().setFullYear(this.yearSelected, this.monthSelected, 1);
        let to = new Date().setFullYear(this.yearSelected, this.monthSelected + 1, 0);

        const parameters = new Object();
        parameters['from'] = this.datePipe.transform(from, 'yyyy-MM-dd');
        parameters['to'] = this.datePipe.transform(to, 'yyyy-MM-dd');

        let usersFilter = null;
        for (let user of this.usersSelected) {
        if (usersFilter == null) {
            usersFilter = user.value;
        } else {
            usersFilter += ',' + user.value;
        }
        }
        if (usersFilter) {
            parameters['userIds'] = usersFilter;
        }

        this.reportService.exportReport(this.userContext.srmToken, 'com.netsitech.srm.excel.generator.AbsencesReportGenerator', parameters).
        subscribe(
            data => {
                this.busyProvider.hideBusyIndicator();
                let filename = "Report_Assenze_" + new Date().getTime() + ".xlsx";
                this.download(data, filename);
            },
            error => {
                this.busyProvider.hideBusyIndicator();
                // nei report ci si aspetta un blob pertanto gli eventuali errori in json
                // non vengono correttamente mappati, pertanto non si utilizza la funzione
                // generica handleError ma si visualizza l'errore così com'è.
                this.messageProvider.notifyError(error);
            });
    }

    private download(data: any, filename: string) {
        let blob = new Blob([data], {  type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, filename);
    }

    getGruppo(id: number): string | null {
        const gruppo = this.gruppi.find(userGroup => userGroup.value === id);
        if (gruppo) {
            return gruppo.label;
        }
        return null;
    }

    getGruppoUser(utente: User): string | null {
        if (!this.userInfo || !this.userInfo.managedUsersMap) return null;
        
        const managedUsersMap = this.userInfo.managedUsersMap;
        
        for (const key in managedUsersMap) {
            if (Object.prototype.hasOwnProperty.call(managedUsersMap, key)) {
                const value = managedUsersMap[key];
                if (Array.isArray(value) && value.some(v => v.toLowerCase() === utente.username.toLowerCase())) {
                    return key;
                }
            }
        }
        return null;
    }  

}


export class EventCalendar
{
    date: Date = null;
    enabled: boolean = false;
    isToday: boolean = false;
    users: UserColor[] = [];
    absences: Absence[] = []
    constructor() {}
}

export class WeekEvent
{
    weekId: number = 0;
    events: EventCalendar[] = [];
    
    constructor() {}
}

export class UserColor 
{
    user: string;
    color: string;
    decorationSx: string;
    decorationDx: string;
    userId: string;
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/assenze-prospect/assenze-prospect.component.ts